import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

import * as HttpErrors from 'services/httpErrors';
import { ITokenProvider } from './authenticationService';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.locale('sv');

export interface IFile {
  id: number;
  createdBy: string;
  created: Date;
  fileName: string;
  path: string;
}

export interface IFilesService {
  loadFiles: (customerId: string) => Promise<any>;
  getContactImage: (identifier: string) => Promise<Blob>;
}

export const filesServiceFactory: (
  ApiHostBaseUrl: string,
  tokenProvider: ITokenProvider
) => IFilesService = (ApiHostBaseUrl: string, tokenProvider: ITokenProvider) => {
  return {
    loadFiles: (customerId: string) => {
      return tokenProvider
        .getOrRenewNativeToken()
        .then((accessToken: string) => {
          return fetch(`${ApiHostBaseUrl}/customer/${customerId}/files?PageNumber=1&PageSize=100`, {
            method: 'GET',
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache',
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'bearer ' + accessToken,
            },
            redirect: 'error',
            referrerPolicy: 'no-referrer',
          });
        })
        .then((data: Response) => {
          if (!data.ok) {
            if (data.status === 401) {
              // Not logged in
              throw HttpErrors.UNAUTHORIZED;
            }
            if (data.status === 403) {
              // Not logged in
              throw HttpErrors.FORBIDDEN;
            }
          }
          return data.json() as Promise<IFile[]>;
        });
    },
    getContactImage: (identifier: string) => {
      return tokenProvider
        .getOrRenewNativeToken()
        .then((accessToken: string) => {
          var href = ApiHostBaseUrl + '/customerPortal/GetContactImage?identifier=' + identifier;
          return fetch(href, {
            method: 'POST',
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache',
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'bearer ' + accessToken,
            },
            redirect: 'error',
            referrerPolicy: 'no-referrer',
          });
        })
        .then((response) => {
          return response.blob() as Promise<Blob>;
        })
        .catch((error: any) => {
          console.warn('Could not fetch user details');
          throw error;
        });
    },
  };
};
